import { database } from "../../firebase";

export function getNotifications(uid) {
  return (
    database
      .ref(`/notifications/${uid}`)
      .once("value")
      .then((snapshot) => {
        const array = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const childData = childSnapshot.val();
          array.push({ key, ...childData });
        });
        return array;
      })
  );
}

export function getPost(id) {
  return (
    database
      .ref(`/posts/${id}`)
      .once("value")
      .then((snapshot) => {
        return snapshot.val();
      })
  );
}

export function getSender(uid) {
  return database
    .ref(`/users/${uid}`)
    .once("value")
    .then((snapshot) => {
      return snapshot.val();
    });
}

export async function createVideoCreditz(uid, payload) {
  const newPostKey = payload.id ? payload.id : database.ref().child("user-posts").push().key;
  const updates = {};
  for (const propName in payload) {
    if (payload[propName] === null || payload[propName] === undefined) {
      delete payload[propName];
    }
  }
  updates[`/posts/${newPostKey}`] = payload;
  updates[`/user-posts/${uid}/${newPostKey}`] = 1;
  await database.ref().update(updates);
  return { id: newPostKey, ...payload };
}

export async function createNewNotification(to, payload) {
  const newPostKey = database.ref().child("notifications").push().key;
  const updates = {};
  for (const propName in payload) {
    if (payload[propName] === null || payload[propName] === undefined) {
      delete payload[propName];
    }
  }
  updates[`/notifications/${to}`] = payload;
  // updates[`/user-posts/${uid}/${newPostKey}`] = 1;
  await database.ref().update(updates);
  return { id: newPostKey, ...payload };
}


export function updateNotification(uid, notifId, status) {
  return database
    .ref(`/notifications/${uid}/${notifId}`)
    .update({
      status
    })
    .then(() => {
      return true;
    })
    .catch(() => false);
}
